<ng-container *ngIf="virtualSports?.length">
    <div class="header">
        <div class="title">{{ model.title }}</div>
    </div>
    <div class="body">
        <div class="scrolling-wrapper">
            <ms-scroll-adapter [scrollItems]="virtualSports">
                <div class="img-wrapper" *ngFor="let sport of virtualSports">
                    <a class="link" (click)="onSportClick(sport)"> <img disableOptimizedSrcset height="80" width="80" [ngSrc]="sport.imageSrc" /> </a>
                </div>
            </ms-scroll-adapter>
        </div>
    </div>
</ng-container>
